import React from 'react';
import checkmarkIcon from '../static/icons/checkmark.png';
import rejectedIcon from '../static/icons/reject.png';
import { useLocation } from 'react-router-dom';

export default function ThirdPartyCompliance(props) {
  const location = useLocation();

  React.useEffect(() => {
    props.hideLoader();
  }, [props]);

  return (
    <div className="container w-full max-w-xs h-full mx-auto">
      <div className="successSubmit bg-blue-gradient shadow-md px-8 pt-6 pb-8 mb-4 mt-4">
        <img className="object-scale-down h-12 w-full" src={location.state?.passed === 'compliance' ? checkmarkIcon : rejectedIcon} alt="Success" />
        <p className="text-lg font-extrabold text-center text-white successText">{location.state?.passed === 'compliance' ? 'Approved' : 'Rejected'}</p>
        {/* {inviteCode && <p className="text-center bigLetters">{inviteCode}</p>} */}
      </div>
    </div>
  );
}
